import { List } from 'antd';
import React from 'react';
import { CheckListType } from './type';
import { Descriptions } from 'app/modules/ui';

export type CheckListProps = {
  value: CheckListType;
  descriptionDef: any[];
};

export const CheckList = (props: CheckListProps) => {
  const { descriptionDef, value } = props;
  return (
    <List
      dataSource={value}
      split={false}
      renderItem={(record, index) => {
        return (
          <List.Item>
            <Descriptions
              title={`#${index + 1}. ${record.checkPointName}`}
              column={1}
              key={record.checkPointName || index}
              items={descriptionDef}
              value={record}
            />
          </List.Item>
        );
      }}
    ></List>
  );
};
